document.addEventListener("DOMContentLoaded", function() {
    const contentContainer = document.querySelector('div.article-content');

    if (contentContainer) {
        const jumpToElement = Array.from(contentContainer.querySelectorAll('p>strong')).find(el => el.textContent.trim() === 'Jump to:')?.parentNode;
    
        if (jumpToElement) {
            const nextSibling = jumpToElement.nextElementSibling;
        
            if (nextSibling && nextSibling.tagName.toLowerCase() === 'ul') {
                jumpToElement.classList.add('jump-to');
                nextSibling.classList.add('jump-to');
            }
        }
    }
    const targetContainer = document.querySelector('div.article_featured_products');

    if (targetContainer) {
        const elementToMove = document.querySelector('div.nap-featured-products');
        elementToMove.style.display = 'block';
        targetContainer.appendChild(elementToMove);
    }
});